module.exports = __webpack_public_path__ + "static/media/gradientLeft.054008c7.png";